import {Injectable} from '@angular/core';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {HistoryDocumentListItem, HistoryViewerData} from '@shared/models/history.model';
import {FileService} from './file.service';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {

  constructor(
    private http: HttpClient,
    private fileService: FileService
  ) {
  }

  async getDocuments(
    page: number,
    size: number,
    startDate?: number,
    endDate?: number,
    centerId?: number,
    serviceId?: number,
    professionalId?: number,
    documentTypeId?: number
  ): Promise<HistoryDocumentListItem[]> {

    let httpParams = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (startDate) {
      httpParams = httpParams.set('startDate', startDate.toString());
    }

    if (endDate) {
      httpParams = httpParams.set('endDate', endDate.toString());
    }

    if (centerId) {
      httpParams = httpParams.set('centerId', centerId.toString());
    }

    if (serviceId) {
      httpParams = httpParams.set('serviceId', serviceId.toString());
    }

    if (professionalId) {
      httpParams = httpParams.set('professionalId', professionalId.toString());
    }

    if (documentTypeId) {
      httpParams = httpParams.set('documentTypeId', documentTypeId.toString());
    }

    const url = '/api/v1/document';
    return this.http.get<HistoryDocumentListItem[]>(url, {params: httpParams}).toPromise();
  }

  async getDocumentsHttp(
    page: number,
    size: number,
    startDate?: number,
    endDate?: number,
    centerId?: number,
    serviceId?: number,
    professionalId?: number,
    documentTypeId?: number
  ): Promise<HttpResponse<HistoryDocumentListItem[]>> {

    let httpParams = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (startDate) {
      httpParams = httpParams.set('startDate', startDate.toString());
    }

    if (endDate) {
      httpParams = httpParams.set('endDate', endDate.toString());
    }

    if (centerId) {
      httpParams = httpParams.set('centerId', centerId.toString());
    }

    if (serviceId) {
      httpParams = httpParams.set('serviceId', serviceId.toString());
    }

    if (professionalId) {
      httpParams = httpParams.set('professionalId', professionalId.toString());
    }

    if (documentTypeId) {
      httpParams = httpParams.set('documentTypeId', documentTypeId.toString());
    }

    const url = '/api/v1/document';
    return this.http.get<HistoryDocumentListItem[]>(url, {params: httpParams, observe: 'response'}).toPromise();
  }

  async getDownloadDocument(documentId: string): Promise<void> {
    const url = '/api/v1/document/download';
    let httpParams = new HttpParams().set('documentId', documentId.toString());
    await this.fileService.downloadPdf(url, httpParams);
  }

  async getDownloadDocumentResultsViewer(documentId: string): Promise<void> {
    const url = `/api/v1/viewer/document/${documentId}/result`;
    await this.fileService.downloadPdf(url);
  }

  async getOpenViewerResultsUrl(documentId: string): Promise<void> {
    const url = `/api/v1/viewer/document/${documentId}/result/url`;
    const viewerUrl = await this.http.get(url, {responseType: 'text'}).toPromise();
    window.location.href = viewerUrl;
  }

  async getOpenViewerDataImage(documentId: string, code: string): Promise<void> {
    const url = `/api/v1/viewer/document/${documentId}/image`;
    let httpParams = new HttpParams();
    if (code) {
      httpParams = httpParams.set('accessionNumber', code);
    }

    const historyViewerDataUrl = await this.http.get(url, {params: httpParams, responseType: 'text'}).toPromise();
    // this.fileService.openUrl(historyViewerData.url); // Not working in Safari (iOS) with "Blocking pop-ups"
    window.location.href = historyViewerDataUrl;
  }

  getShareDocumentResults(documentId: string): Promise<HistoryViewerData> {
    const url = '/api/v1/share/document';
    const httpParams = new HttpParams().set('documentId', documentId.toString())
    return this.http.post<HistoryViewerData>(url, {}, {params: httpParams}).toPromise();
  }

  getShareDocumentResultsViewer(documentId: string): Promise<HistoryViewerData> {
    const url = `/api/v1/share/viewer/document/${documentId}/result`;
    return this.http.post<HistoryViewerData>(url, {}).toPromise();
  }

  getShareDocumentResultsViewerUrl(documentId: string): Promise<HistoryViewerData> {
    const url = `/api/v1/share/viewer/document/${documentId}/result/url`;
    return this.http.post<HistoryViewerData>(url, {}).toPromise();
  }

  getShareImageResults(documentId: string, code: string): Promise<HistoryViewerData> {
    const url = `/api/v1/share/viewer/document/${documentId}/image`;
    let httpParams = new HttpParams();
    if (code) {
      httpParams = httpParams.set('accessionNumber', code);
    }

    return this.http.post<HistoryViewerData>(url, {}, {params: httpParams}).toPromise();
  }
}
